export const isFunction = value => {
  return value && typeof value === 'function';
};